<template>
  <div>
    <span v-show="showFailedPlayTcpa" class="text-danger">TCPA Playback Failed, read TCPA above.</span>
    <button class="btn btn-primary" @click="playTcpa" v-show="submitStep === 1">Play TCPA</button>

    <div v-show="submitStep === 2" class="loading text-center">
        <span class="text-info"><strong>Playing TCPA</strong></span>
        <br /><img :src="loadingImg" />
    </div>

    <div v-show="submitStep === 3" class="text-center">
        <span class="text-info"><strong>Replay TCPA?</strong></span>
        <br />
        <button class="btn btn-primary" @click="playTcpa">Yes</button>
        &nbsp;&nbsp;&nbsp;
        <button class="btn btn-success" @click="donePlayTcpa">No</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import fiveNineLogin from '../js/FiveNineLogin'
import fiveNinePlayTcpa from '../js/FiveNinePlayTcpa'

export default {
  name: 'PlayTCPAButton',
  emits: ['submit'],
  props: {
    websocketName: String,
    opened: Boolean,
    hasPlayTcpa: Boolean
  },
  data () {
    return {
      hasAccepted: false,
      submitStep: 1,
      loadingImg: process.env.BASE_URL + 'loading.gif',
      fiveNineUrl: null,
      fiveNineAgentId: null,
      fiveNineWebSocket: null,
      fiveNineTransferId: null,
      fiveNinePingIntervalHandle: null,
      playTcpaTimeout: null,
      showFailedPlayTcpa: false
    }
  },
  unmounted () {
    this.closeWebsocket()
  },
  methods: {
    playTcpa () {
      fiveNinePlayTcpa(this.fiveNineUrl, this.fiveNineAgentId, this.tcpaCampaign).then(result => {
        if (result === null) {
          return null
        }
        result.json().then(parsed => {
          this.fiveNineTransferId = parsed.id
        })
      })

      this.playTcpaTimeout = setTimeout(() => {
        this.donePlayTcpa()
        this.showFailedPlayTcpa = true
      }, 45000)

      this.submitStep = 2
      this.$emit('disableCancel', true)
    },

    submit () {
      this.submitStep = 3
    },

    donePlayTcpa () {
      this.submitStep = 4
      this.$emit('submit')
    },

    closeWebsocket () {
      if (this.fiveNineWebSocket !== null) {
        this.fiveNineWebSocket.close()
        this.fiveNineWebSocket = null
      }
    },

    openWebsocket () {
      // Safe guard not to open websocket if not enabled
      if (!this.hasPlayTcpa) {
        return
      }

      fiveNineLogin().then(response => {
        if (response === null) {
          return
        }

        this.fiveNineUrl = response.url
        this.fiveNineAgentId = response.agentId

        if (this.fiveNineWebSocket == null) {
          var wsurl = this.getWebsocketUrl()
          this.fiveNineWebSocket = new WebSocket(wsurl)
          var that = this

          this.fiveNineWebSocket.onmessage = function (evt) {
            var wsData = JSON.parse(evt.data)
            if (wsData.context.eventReason === 'CONFERENCE_PARTICIPANT_DISCONNECTED_BY_THEMSELF' && wsData.payLoad.id === that.fiveNineTransferId) {
              that.submit()
            } else if (wsData.context.eventReason === 'CONFERENCE_PARTICIPANT_DISCONNECTED_BY_AGENT' && wsData.payLoad.id === that.fiveNineTransferId) {
              that.submitStep = 1
            }
          }

          this.fiveNineWebSocket.onopen = function () {
            // every 15 seconds
            that.fiveNinePingIntervalHandle = window.setInterval(function () {
              if (typeof that.fiveNineWebSocket !== 'undefined') {
                that.fiveNineWebSocket.send('ping')
              }
            }, 15 * 1000)
          }

          this.fiveNineWebSocket.onclose = function () {
            window.clearInterval(that.fiveNinePingIntervalHandle)
          }
        }
      })
    },

    getWebsocketUrl () {
      return 'wss://' + this.fiveNineUrl + '/appsvcs/ws/' + this.websocketName
    }

  },
  computed: {
    ...mapState({
      consumer: state => state.consumer.currentConsumer
    }),
    ...mapGetters({
      hasDisplayedType: 'consumer/hasDisplayedOverlayDisclosure',
      leadInfo: 'consumer/lead/leadInfo',
      tcpaCampaign: 'consumer/tcpaCampaign'
    })
  },

  watch: {
    opened (val) {
      if (val) {
        this.submitStep = 1
        this.openWebsocket()
      } else {
        this.closeWebsocket()
        this.showFailedPlayTcpa = false
      }
    },

    submitStep (val) {
      if (val === 2) {
        this.$emit('disableCancel', true)
      } else {
        if (this.playTcpaTimeout !== null) {
          clearTimeout(this.playTcpaTimeout)
        }

        this.$emit('disableCancel', false)
      }
    }
  }
}
</script>

<style lang="scss">
.disclosure.modal-backdrop.show {
  background-color: black;
  opacity: 0.85;
}
</style>
